<div [class.has-danger]="!valid" [disableTooltip]="!timeDisabled"
     ngbTooltip="Nur für eintägige Aktionen kann ein Start- und Endzeitpunkt festgelegt werden!"
     placement="right" class="d-flex flex-column align-items-start flex-md-row d-md-inline-flex align-items-md-center mt-2">
  <datepicker (onSelect)="onChange()" *ngIf="!onlyTime" [(date)]="date" [disabled]="dateDisabled"></datepicker>
  <ngb-timepicker (ngModelChange)="timeChanged($event)" [(ngModel)]="time" [disabled]="timeDisabled" *ngIf="!timeDisabled"
                  [minuteStep]="minuteStep"
                  [seconds]="seconds" class="ml-0 ml-md-1"></ngb-timepicker>
</div>
